import React, { Fragment } from 'react';

const GuideDocs = () => {
  return (
    <Fragment>
      <div className="content2">
        <div className="container-fluid">
          <div className="row">
            <div className="account-content">
              <div className="col-lg-10" style={{ textAlign: 'justify', lineHeight: 1.8, margin: 'auto' }}>
                <h1>GUIDE UTILISATEUR DE LA PLATEFORME GED / ARCHIVAGE</h1>
                <p>(version 1.1)</p>
                <p>
                  (Syidocs Archivage) est une solution d’archivage numérique pensée pour sécuriser, organiser
                  et valoriser les documents sensibles (diplômes, certificats, cartes professionnelles,
                  contrats, etc.) dans un environnement fiable et adapté aux réalités locales.
                </p>
                <p>Système de Gestion Électronique des Documents (GED/ARCHIVAGE) conçu pour :</p>
                <ul>
                  <li>Centraliser les archives (diplômes, certificats, cartes professionnelles, contrats).</li>
                  <li>Garantir la traçabilité et la sécurité des documents.</li>
                  <li>Appliquer des règles de conservation conformes aux normes archivistiques.</li>
                  <li>Simplifier l’accès et la recherche pour les agents et les usagers.</li>
                </ul>
                <p><em>--Guide utilisateur et administrateur --</em></p>
                <p>
                  Ce guide décrit les usages principaux de l'application GED telle qu'elle est implémentée
                  dans ce dépôt. Il couvre les rôles, la gestion du plan de classement, les profils
                  d'archivage, la conservation, les archives et la recherche avancée.
                </p>

                <section className="mb-4">
                  <h4>1 Glossaires des termes</h4>
                  <p>Glossaire des termes – GED / Archivage</p>
                  <ul>
                    <li>
                      <strong>Archivage</strong> : Processus de classement, conservation et gestion des
                      documents afin d’assurer leur disponibilité, leur intégrité et leur traçabilité dans
                      le temps.
                    </li>
                    <li>
                      <strong>Archive</strong> : Document (papier ou numérique) qui a été produit ou reçu
                      dans le cadre d’une activité et qui est conservé pour sa valeur administrative,
                      juridique, probante ou historique.
                    </li>
                    <li>
                      <strong>Profil d’archive</strong> : Ensemble de champs et règles spécifiques appliqués
                      à un type de document (ex. Diplôme, Certificat, Carte professionnelle). Chaque profil
                      définit les métadonnées, la durée de conservation et le niveau de confidentialité.
                    </li>
                    <li>
                      <strong>Plan de classement</strong> : Structure hiérarchique qui organise les archives
                      par catégories (ex. 02.01 Diplômes, 02.02 Certificats). Il sert de référentiel pour
                      ranger et retrouver les documents.
                    </li>
                    <li>
                      <strong>Métadonnées</strong> : Informations descriptives associées à un document
                      (titre, type, date, producteur, titulaire, confidentialité, durée de conservation).
                      Elles permettent de rechercher et gérer les archives efficacement.
                    </li>
                    <li>
                      <strong>Référence</strong> : Identifiant unique attribué à chaque archive, construit
                      selon une nomenclature officielle (ex. ClassePlan-Année-Numéro). Elle garantit
                      l’unicité et la traçabilité.
                    </li>
                    <li>
                      <strong>CSV (Comma-Separated Values)</strong> : Format de fichier tabulaire utilisé
                      pour importer ou exporter en masse les métadonnées des archives. Chaque ligne
                      représente un document, chaque colonne une information.
                    </li>
                    <li>
                      <strong>Archivage intermédiaire</strong> : Phase où les documents sont conservés pour
                      une durée limitée, selon les règles de conservation, avant leur transfert en archivage
                      définitif ou leur destruction.
                    </li>
                    <li>
                      <strong>Archivage définitif</strong> : Phase où les documents sont conservés de manière
                      permanente pour leur valeur probante, patrimoniale ou historique.
                    </li>
                    <li>
                      <strong>Destruction sécurisée</strong> : Procédure de suppression définitive des
                      documents arrivés en fin de conservation, réalisée de manière à garantir la
                      confidentialité et l’intégrité (broyeur, effacement certifié).
                    </li>
                    <li>
                      <strong>Confidentialité</strong> : Niveau d’accès attribué à une archive (Interne,
                      Restreint, Confidentiel, Très confidentiel). Il détermine qui peut consulter le
                      document.
                    </li>
                    <li>
                      <strong>Règle de conservation</strong> : Directive qui fixe la durée de conservation
                      d’un document et son sort final (conservation ou destruction).
                    </li>
                    <li>
                      <strong>OCR (Optical Character Recognition)</strong> : Technologie qui permet de
                      reconnaître automatiquement le texte dans un document scanné et de l’intégrer comme
                      métadonnées.
                    </li>
                    <li>
                      <strong>Journal d’accès</strong> : Historique des consultations et actions réalisées
                      sur une archive, garantissant la traçabilité et la sécurité.
                    </li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h4>2 Structure de menu et d’écrans</h4>
                  <p>Les descriptions suivantes présente la structure des menus et écran d’utilisation</p>
                  <ul>
                    <li>
                      1 : Entête général qui présente logo et menu d’accès rapide aux page accueil général,
                      ressources privées sécurisées, information et aide support.
                    </li>
                    <li>2 : Accès à la page de gestion du compte, au menu de déconnexion;</li>
                    <li>
                      3 : Menu latérale qui permet de naviguer entre les différents modules de la
                      plateforme;
                    </li>
                    <li>
                      4 : Accès-plan, sous plan et dossiers d’archives: Zone de filtre des archives selon le
                      plan de classement, sous-éléments des plans et récupération des dossiers directs de
                      plan;
                    </li>
                    <li>
                      5 : Zone archives : Écran de consultation et gestion des documents archivés selon les
                      filtres effectués sur les plans et dossiers. Fonctionnalités : recherche, filtres. Le
                      bouton N°6 permet d’archiver directement dans le plan/dossier en cours.
                    </li>
                    <li>7 : Référence de l’archive, élément en Id unique pour chaque archive</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h4>3 Plan de classement</h4>
                  <p>
                    Un plan de classement est une arborescence qui regroupe les documents en catégories
                    cohérentes, selon des critères fonctionnels (activités, processus), thématiques (types de
                    documents), ou organisationnels (services, départements).
                  </p>
                  <h5>Objectifs du plan de classement</h5>
                  <h6>Principe</h6>
                  <p>
                    Chaque direction ou service est une classe principale dans le plan. À l’intérieur, on
                    définit des sous-classes correspondant aux activités, types de documents ou processus
                    propres à ce service. Cela permet de savoir qui est responsable de chaque archive et de
                    limiter les accès selon les rôles.
                  </p>
                  <p>
                    Pour la création du plan, Allez dans la section plan de classement, puis nouveau plan :
                    Vous renseignez les informations relatives à votre plan. Notez que les informations de
                    cette section ci-dessous sont d’ordres générales.
                  </p>
                </section>

                <section className="mb-4">
                  <h4>4 Profil d’archive</h4>
                  <p>
                    Un profil d’archive est une fiche descriptive normalisée qui définit les caractéristiques
                    essentielles d’un document ou d’une série documentaire dans un système de gestion (GED ou
                    archivage). C’est en quelque sorte la carte d’identité de l’archive, qui permet de
                    l’identifier, de la classer, de la conserver et de la retrouver facilement.
                  </p>
                  <h5>Objectifs d’un profil d’archive</h5>
                  <ul>
                    <li>Assurer une traçabilité complète du document.</li>
                    <li>Faciliter l’indexation et la recherche.</li>
                    <li>Définir les règles de conservation (durée, support, format).</li>
                    <li>Garantir la sécurité et la confidentialité.</li>
                    <li>Uniformiser la gestion documentaire dans l’organisation.</li>
                  </ul>
                  <h5>Contenu typique d’un profil d’archive</h5>
                  <p>Un profil d’archive comporte généralement les éléments suivants :</p>
                  <ul>
                    <li>Identifiant unique : code ou numéro attribué à l’archive.</li>
                    <li>Titre / objet : description claire du contenu.</li>
                    <li>Type de document : diplôme, certificat, contrat, rapport, etc.</li>
                    <li>Date(s) : date de création</li>
                    <li>Producteur / service d’origine : qui a créé ou transmis le document.</li>
                    <li>Support : papier numérisé, PDF/A, image, etc.</li>
                    <li>Métadonnées : mots-clés, classification, index thématique.</li>
                    <li>Durée de conservation : combien de temps le document doit être gardé.</li>
                    <li>
                      Sort final : destruction, conservation permanente, transfert aux archives
                      historiques.
                    </li>
                    <li>Niveau de confidentialité : public, interne, restreint, confidentiel, très confidentiel.</li>
                    <li>Règles d’accès : qui peut consulter, modifier ou supprimer.</li>
                  </ul>
                  <p>
                    Zone de captation OCR à définir pour chaque profil. Eléments de configuration des champs
                    ocr
                  </p>
                  <ul>
                    <li>Type (texte, nombre, date, booleen) pour aider au casting.</li>
                    <li>
                      Keywords (zone de lecture) (liste séparée par virgules/points-virgules/retours ligne).
                    </li>
                    <li>
                      Pattern regex (prioritaire si renseigné). Ex de pattern :{' '}
                      <code>Facture\\s*#\\s*(\\w+)</code>
                    </li>
                    <li>Métadonnées libres : metadata (JSON)</li>
                    <li>Extraction OCR :</li>
                    <li>Preview OCR : <code>POST /ged/ocr/preview</code> (archiveProfileId + file)</li>
                    <li>Capture automatique lors de l'ajout de version</li>
                    <li>Les méta données capturées sont ajoutées sans écraser les valeurs existantes.</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h4>5 Règle de conservation</h4>
                  <p>
                    Une règle de conservation est une directive qui définit combien de temps un document ou
                    une archive doit être conservé, dans quel format, et ce qu’il faut en faire une fois cette
                    durée écoulée (destruction, transfert, conservation permanente).
                  </p>
                  <h5>Objectifs d’une règle de conservation</h5>
                  <ul>
                    <li>
                      Respecter les obligations légales et réglementaires (ex. : diplômes conservés à vie,
                      contrats 10 ans après expiration).
                    </li>
                    <li>Garantir la traçabilité et la disponibilité des documents pendant leur durée utile.</li>
                    <li>Optimiser l’espace de stockage en évitant la conservation inutile.</li>
                    <li>Assurer la sécurité et la confidentialité des données sensibles.</li>
                  </ul>
                  <h5>Éléments d’une règle de conservation</h5>
                  <ul>
                    <li>Durée de conservation : nombre d’années ou illimitée.</li>
                    <li>Support : papier, numérique (PDF/A, image, base GED).</li>
                    <li>Sort final :</li>
                    <li>Conservation permanente (archives historiques)</li>
                    <li>Destruction sécurisée (shredding, effacement certifié)</li>
                    <li>Transfert vers un autre service ou organisme</li>
                    <li>Niveau de confidentialité : public, interne, restreint, confidentiel, très confidentiel.</li>
                    <li>Responsable : service ou direction en charge de l’application de la règle.</li>
                  </ul>
                  <h5>Dans le plan de classement</h5>
                  <ul>
                    <li>Règle de conservation : directive générale qui fixe la politique pour une catégorie de documents.</li>
                    <li>Durée de conservation : valeur standard définie pour une classe documentaire.</li>
                    <li>Confidentialité : niveau attribué à une catégorie de documents, valable pour tous les documents de cette classe.</li>
                  </ul>
                  <p>Ici, le plan de classement fixe les règles pour un ensemble de documents.</p>
                  <h5>Dans une archive (document individuel)</h5>
                  <ul>
                    <li>Règle de conservation : appliquée concrètement au document, avec traçabilité.</li>
                    <li>Durée de conservation : calculée pour ce document précis, avec une date de fin.</li>
                    <li>Confidentialité : attribuée au document lui-même, parfois plus fine que la règle générale.</li>
                  </ul>
                  <h5>Exemple de règles de conservation</h5>
                  <ul>
                    <li>Diplômes : conservation illimitée, format PDF/A, très confidentiel, conservation permanente.</li>
                    <li>Certificats : 10 ans après délivrance, format PDF, confidentiel, destruction sécurisée après délai.</li>
                    <li>Cartes professionnelles : 5 ans après expiration, format image/PDF, confidentiel, destruction sécurisée.</li>
                    <li>Contrats : 10 ans après expiration, format PDF/A, restreint, conservation numérique + copie papier signée.</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h4>6 Gestion des archives</h4>
                  <h5>Technique de référence des archives</h5>
                  <p>Une archive reçoit un identifiant unique, immuable et non réutilisable.</p>
                  <p>L’identifiant ne doit jamais changer, même si le contenu est modifié ou déplacé.</p>
                  <p>Toute modification majeure du contenu crée une nouvelle version liée à l’identifiant d’origine.</p>
                  <h5>Format d’identifiant (référence)</h5>
                  <p>Modèle appliqué :</p>
                  <p>
                    <code>ARC-&lt;REF_PLAN&gt;-&lt;ORIGINE&gt;-&lt;DATE&gt;-&lt;SEQUENCE&gt;-&lt;CHECK&gt;</code>
                  </p>
                  <p><code>ARC-DR-P1-SR1-20260115-000004-B16D</code></p>
                  <p>Règles :</p>
                  <ul>
                    <li>REF_PLAN = Référence du plan de classement</li>
                    <li>ORIGINE = code court du service producteur (3 caractères)</li>
                    <li>DATE = date de création de l’archive</li>
                    <li>SEQUENCE = compteur séquentiel par jour et par origine</li>
                    <li>CHECK = checksum court (hash tronqué ou modulo) pour détecter les erreurs</li>
                  </ul>
                  <h5>Création d’archive</h5>
                  <p>
                    A ce niveau deux méthodes de création d’archive sont disponibles : la méthode archive
                    individuelle et l’import de masse avec un fichier manifest.csv
                  </p>
                  <p>
                    Lors de la création de l’archive, le service producteur est important et définit
                    l’origine du document. Si le service n’est pas disponible au moment de la création de
                    l’archive, vous pouvez en créer directement.
                  </p>
                  <p>Le service producteur est pris en compte dans le référencement de l’archive.</p>
                  <h5>Import en masse</h5>
                  <p>Rôles autorisés : Archiviste, Assistant.</p>
                  <p>Il existe 02 moyens pour faire une importation en masse dans la Ged</p>
                  <p><strong>MÉTHODE 1 : IMPORT FICHIER ZIP UNIQUE SANS FICHIER .CSV (manifest.csv)</strong></p>
                  <p>Etapes :</p>
                  <p>1) Charger un ZIP avec vos fichiers.</p>
                  <p>3) Lancer preview pour vérifier les erreurs.</p>
                  <p>
                    Si le fichier manifest.csv est absent du zip, le système procédera à la méthode de
                    captation OCR définie dans le profile d’archive. Il est possible de Toujours compléter
                    les métadonnées lors du dépôt, en utilisant le CSV standard généré à partir du dépôt ou
                    traiter les métadonnées directement dans le champ json pour les imports en masse.
                  </p>
                  <p>
                    Il est conseillé pour la création du modèle standard de manifest.csv applicable au
                    plan de classement d’exporter via le bouton d’export le manifest généré par la
                    prévisualisation du dossier zippé.
                  </p>
                  <p>Edition et mise à jour du CSV pour l’import</p>
                  <p>4) Lancer le bouton “importer avec mapping” pour créer les archives.</p>
                  <p><strong>MÉTHODE 2 : IMPORT UNIQUE VIA FICHIER .CSV (manifest.csv)</strong></p>
                  <p>
                    L'import CSV avec validation complète et blocage si erreur ; les chemins file sont
                    obligatoirement relatifs au dossier d’import CSV côté serveur, et la création ne démarre
                    que si tout est OK.
                  </p>
                  <h5>Détails et contexte</h5>
                  <p>1.Import CSV dans la GED</p>
                  <p>
                    Importer le zip contenant le manifest.csv . Chaque import de masse doit contenir un
                    fichier nommé manifest.csv ce document contient les informations sur chaque fichier et y
                    compris ses métadonnées qui seront ajoutées au fichier.
                  </p>
                  <p>Téléverser le zip avec le fichier CSV préparé.</p>
                  <p>Le système vérifie :</p>
                  <ul>
                    <li>La conformité du format (colonnes présentes)</li>
                    <li>L’unicité des références OU laisser les référence à vides</li>
                    <li>L’existence des fichiers liés (file).</li>
                  </ul>
                  <p>2. Validation</p>
                  <ul>
                    <li>Si tout est correct → les archives sont créées automatiquement.</li>
                    <li>Si erreurs → le système génère un rapport d’erreurs (ex. ID manquant, fichier introuvable).</li>
                    <li>L’user corrige le CSV et relance l’import.</li>
                  </ul>
                  <h5>Validation et conservation</h5>
                  <p>La validation suit les étapes Brouillon → En revue → Validée. Une archive en revue peut être renvoyée « À corriger » avec un motif, puis soumise de nouveau.</p>
                  <p>Changement de validation :</p>
                  <ul>
                    <li><code>POST /ged/documents/{'{id}'}/workflow</code></li>
                  </ul>
                  <p>Après validation, la conservation est suivie séparément. Une échéance dépassée apparaît comme une alerte « À traiter » ; elle ne transfère ni ne détruit automatiquement le document. La corbeille relève de la suppression technique.</p>
                  <p>Pour un import ZIP, le rapport et l’identifiant du lot restent visibles après l’import. Un archiviste ou un administrateur peut valider en une fois les archives conformes depuis ce rapport ou depuis la liste filtrée sur le lot. Les archives non admissibles restent en brouillon avec leur motif.</p>
                  <p>Rôles autorisés : Admin, Archiviste.</p>
                  <p>Consultation et export</p>
                  <ul>
                    <li><code>Visualiser : GET /ged/documents/{'{id}'}/view</code></li>
                    <li><code>Télécharger : GET /ged/documents/{'{id}'}/download</code></li>
                    <li><code>allowExport=false</code> bloque l'export pour les non-admin.</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h4>7 Recherche avancée</h4>
                  <p>Endpoint SQL :</p>
                  <ul>
                    <li><code>POST /ged/documents/search-advanced</code></li>
                  </ul>
                  <p>Ancienne URL compatible (même recherche PostgreSQL) :</p>
                  <ul>
                    <li><code>POST /ged/documents/search-advanced-typesense</code></li>
                  </ul>
                  <p>Filtres possibles :</p>
                  <ul>
                    <li>planIds, folderIds, profileIds, regleIds, serviceIds</li>
                    <li>status, hasFile, confidentialityMax</li>
                    <li>dateFrom, dateTo</li>
                  </ul>
                  <p>Règles avancées (rules) :</p>
                  <ul>
                    <li>
                      Champs supportés : title, reference, status, plan, folder, profile, service, règle,
                      confidentiality, createdAt, retentionEndAt, metadata
                    </li>
                    <li>Opérateurs : contains, equals, gt/gte, lt/lte, isEmpty, notEmpty</li>
                    <li>mode : match=all ou match=any</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h4>8 Rôles et Utilisateurs</h4>
                  <p>Responsabilités:</p>
                  <ul>
                    <li>Archiviste: gère plans/dossiers, valide conservation, supervise indexation</li>
                    <li>Assistant: dépose et met à jour dans ses dossiers autorisés</li>
                    <li>Lecteur: lecture seule, sans export si non autorisé</li>
                    <li>Auditeur (Archivist ou Assistant si autorisé) : lecture + export limite, accès horodatage et journal</li>
                    <li>Admin: gestion comptes, rôles, paramètres globaux, audit</li>
                  </ul>
                  <p>Règle d’accès : un utilisateur voit une archive si autorisé</p>
                  <p>Autorisation : service, plan, dossier, niveau de confidentialité</p>
                  <p>Filtrage initial</p>
                  <p>
                    A l’accueil des archives : seul uniquement plans et dossiers autorisés pour l’utilisateur
                    sont accessibles via son dashboard. Si l’utilisateur a des dossiers explicitement définis
                    → limiter la liste
                  </p>
                  <p>Actions par rôle</p>
                  <ul>
                    <li>Archiviste: tout sur plan/dossier (création, validation, indexation)</li>
                    <li>Assistant: ajout + mise à jour seulement dans dossiers autorisés</li>
                    <li>Lecteur: lecture seule (pas d’export si non autorisé)</li>
                    <li>Admin: tout + audit</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h4>9 Processus d’élimination d’archives</h4>
                  <h5>Suppression des archives</h5>
                  <h6>Objectif fonctionnel</h6>
                  <ul>
                    <li>
                      Un assistant sélectionne des archives à éliminer pour raisons d’erreur, de doublon
                      ou de fin de cycle de vie.
                    </li>
                    <li>Ces archives passent en Corbeille (suppression programmée).</li>
                    <li>Un archiviste valide et supprime définitivement.</li>
                    <li>Chaque étape est tracée : qui, quand, pourquoi, quoi.</li>
                  </ul>
                  <h6>Titre de l’action</h6>
                  <p><strong>Envoyer en élimination (archives)</strong></p>
                  <h6>Contenu</h6>
                  <p>
                    Texte explicatif : les archives seront déplacées vers la corbeille. La suppression
                    définitive est réservée à l’archiviste.
                  </p>
                  <p>Champ obligatoire : motif d’élimination.</p>
                  <ul>
                    <li>Erreur de classement</li>
                    <li>Cycle de vie atteint</li>
                    <li>Doublon</li>
                    <li>Autre (préciser)</li>
                  </ul>
                  <h6>Rôles</h6>
                  <ul>
                    <li>Assistant : propose l’élimination et envoie en Corbeille.</li>
                    <li>Archiviste : décide la suppression définitive ou la restauration.</li>
                  </ul>
                  <h6>Liste des archives (vue assistant)</h6>
                  <ul>
                    <li>Colonnes : Titre, Référence, Type, Date, Statut.</li>
                    <li>Action : Mettre en corbeille.</li>
                    <li>Modal obligatoire : Raison (Erreur / Cycle de vie atteint / Autre).</li>
                    <li>Commentaire obligatoire si le motif est Autre.</li>
                    <li>Résultat : statut = En corbeille.</li>
                  </ul>
                  <h6>Corbeille (vue archiviste)</h6>
                  <ul>
                    <li>Filtres : date de mise en corbeille, motif, initiateur, type d’archive.</li>
                    <li>Actions : Supprimer définitivement, Restaurer (retour à Active).</li>
                    <li>Confirmation forte : saisie de <strong>SUPPRIMER</strong> pour éviter les erreurs.</li>
                    <li>Raison de suppression finale (exemple : Validation archiviste).</li>
                    <li>Affichage des métadonnées de traçabilité : qui a mis en corbeille, pourquoi, quand.</li>
                  </ul>
                  <h6>Détail d’une archive</h6>
                  <p>Section Traçabilité :</p>
                  <ul>
                    <li>Événements : création, modification, mise en corbeille, suppression.</li>
                    <li>Champs : acteur, date/heure, motif, commentaire, action.</li>
                  </ul>
                  <h5>Consultation des logs sur les événements des archives : qui a fait quoi et quand</h5>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default GuideDocs;
